// 🔧 index.js
// ✅ Purpose: Entry point for the Silent Auction Demo Engine
// ✅ Features:
// - Exposes runAuctionEngine()
// - Runs Auction Builder when Silent Auction is selected
// - Returns standardized Demo Report v2-compatible results
// - Fully block-commented for clarity and future devs

import { buildAuction } from "./auction_builder";

export const runAuctionEngine = async ({ demoContext } = {}) => {
  console.log("🔨 Silent Auction Engine started.");

  const result = await buildAuction({ demoContext });

  console.log("✅ Silent Auction Engine completed.", { result });

  return result;
};